<template>
  <div>
    <h2>我的权限</h2>

    <!-- 权限列表展示 -->
    <el-table :data="permissions" style="width: 100%" stripe>
      <el-table-column prop="permissionName" label="权限名称" width="200"></el-table-column>
      <el-table-column prop="status" label="状态" width="150">
        <template #default="{ row }">
          <el-tag :type="row.hasPermission ? 'success' : 'info'">
            {{ row.hasPermission ? '已授权' : '未授权' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="{ row }">
          <el-button
              type="primary"
              size="small"
              :disabled="row.hasPermission"
              @click="applyPermission(row)"
          >
            申请权限
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 申请权限的对话框 -->
    <el-dialog
        v-model="dialogVisible"
        title="申请权限"
        width="400px"
    >
      <p>您正在申请 <strong>{{ selectedPermission }}</strong> 权限，提交后管理员会进行审核。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmApplyPermission">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import axios from '@/axios'
export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      permissionMapping: {
        can_add_admin: "增加管理员",
        can_delete_admin: "删除管理员",
      },
      // 权限列表
      permissions: [
        { id: 1, permissionName: '删除管理员', hasPermission: false },
        { id: 2, permissionName: '增加管理员', hasPermission: true },
      ],
      dialogVisible: false, // 对话框是否可见
      selectedPermission: '', // 当前选择的权限
    };
  },
  methods: {
    // 点击申请权限按钮
    applyPermission(permission) {
      this.selectedPermission = permission.permissionName;
      this.dialogVisible = true;
    },

    fetchPermissions() {

     axios.get('/Manage/mypermision',{
       params:{
         userid:this.userid
       }
     }).then(response => {
       if(response.data.success) {
         this.permissions = response.data.data;

         this.permissions= this.formattedPermissions()
       }
       else {

         ElMessage.error(response.data.errorMsg)
       }
})
    },
    // 转换权限名称
    formattedPermissions() {
      return this.permissions.map((item) => ({
        ...item,
        permissionName: this.permissionMapping[item.permissionName] || item.permissionName,
      }));
    },
    // 确认申请权限
    confirmApplyPermission() {

      console.log(this.selectedPermission)
      this.dialogVisible = false;
      axios.post('/Manage/applyPermission',{
        userid:this.userid,
        permission:this.selectedPermission
        })
          .then(response => {
            if(response.data.success) {
              ElMessage.success(response.data.data)
            }
            else {
              ElMessage.error(response.data.errorMsg)
            }
          })

    },
  },
  created() {
    this.fetchPermissions();
    console.log(this.userid)
    console.log(this.organizationID)
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
.el-table {
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}
</style>
